import { h } from "preact";

import { getRandomString } from "../../../foundation/utils/string";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "#2684FF";
const DEFAULT_SECONDARY_COLOR = "#0052CC";

function IconJira({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const secondaryFill = color ?? `var(--icon-color, ${DEFAULT_SECONDARY_COLOR})`;

    const pathIds = {
        one: `IconJira-${getRandomString()}`,
        two: `IconJira-${getRandomString()}`
    };

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M15.619 7.55 8.736.667 8.069 0 2.888 5.181.518 7.55a.635.635 0 0 0 0 .895l4.734 4.734 2.817 2.816 5.18-5.181.081-.08 2.289-2.285a.634.634 0 0 0 0-.9zm-7.55 2.813L5.704 7.998l2.365-2.365 2.364 2.365-2.364 2.365z"/>
            <path fill={`url(#${pathIds.one})`} d="M8.069 5.633A3.981 3.981 0 0 1 8.052.019L2.877 5.192l2.816 2.816L8.07 5.633z"/>
            <path fill={`url(#${pathIds.two})`} d="m10.44 7.991-2.371 2.372a3.982 3.982 0 0 1 0 5.63l5.19-5.186-2.82-2.816z"/>
            <defs>
                <linearGradient id={pathIds.one} x1="6.391" y1="3.24" x2="4.042" y2="5.588" gradientUnits="userSpaceOnUse">
                    <stop offset=".18" stop-color={secondaryFill}/>
                    <stop offset="1" stop-color={fill}/>
                </linearGradient>
                <linearGradient id={pathIds.two} x1="9.762" y1="6.125" x2="12.103" y2="8.465" gradientUnits="userSpaceOnUse">
                    <stop offset=".18" stop-color={secondaryFill}/>
                    <stop offset="1" stop-color={fill}/>
                </linearGradient>
            </defs>
        </svg>
    );
}

export default IconJira;
